import { render } from "./AddSurvey.vue?vue&type=template&id=6bc119d4&scoped=true"
import script from "./AddSurvey.vue?vue&type=script&lang=js"
export * from "./AddSurvey.vue?vue&type=script&lang=js"

import "./AddSurvey.vue?vue&type=style&index=0&id=6bc119d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bc119d4"]])

export default __exports__